import React, { useState } from 'react';

import { FormikErrors, useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import {
  createStyles,
  makeStyles,
  Theme,
  Typography,
  Box
} from '@material-ui/core';
import logo from '../common/static/images/rm-logo-small.svg';
import { businessContextId } from '../common/utils/business-configuration';
import { ROUTE } from '../common/utils/route';
import powernetLogo from '../common/static/images/powernet-logo.png';
import { login } from '../common-package/user';
import CustomTextField from '../common-package/CustomTextField';
import MainButton from '../common-package/MainButton';
interface IFormValues {
  userName: string;
  password: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    leftHalf: {
      backgroundColor: theme.palette.primary.main,
      [theme.breakpoints.up('md')]: {
        height: '100%'
      },
      [theme.breakpoints.down('sm')]: {
        height: 0
      }
    },
    height: {
      height: '100vh'
    },
    ditchfieldText: {
      fontWeight: 700,
      textDecoration: 'underline',
      color: theme.palette.secondary.main,
      textDecorationColor: theme.palette.primary.main
    },
    button: {
      backgroundColor: theme.palette.secondary.light
    }
  })
);
const requiredMsg = 'This field is required';
const validateRequired = (
  key: keyof IFormValues,
  errors: FormikErrors<IFormValues>,
  values: IFormValues
) => {
  if (values[key] === '') {
    errors[key] = requiredMsg;
  }
};

const Login: React.FunctionComponent = () => {
  const classes = useStyles();
  const history = useHistory();
  const [activeError, setActiveError] = useState('');
  const formik = useFormik<IFormValues>({
    validateOnChange: false,
    initialValues: {
      userName: '',
      password: ''
    },
    onSubmit: async ({ userName, password }, { setSubmitting }) => {
      setActiveError('');
      setSubmitting(true);
      const result = await login(userName, password, businessContextId);
      const { value, error } = result;
      console.log(value);
      if (value) {
        history.push(ROUTE.HOME_PAGE);
      } else if (error) {
        setActiveError(error || '');
        setSubmitting(false);
      }
    },

    validate: formValues => {
      const formErrors: FormikErrors<IFormValues> = {};
      validateRequired('userName', formErrors, formValues);
      validateRequired('password', formErrors, formValues);
      return formErrors;
    }
  });

  const { values, errors, handleSubmit, isSubmitting, handleChange } = formik;
  const content = (
    <Box height="100vh" overflow="hidden">
      <Box
        position="absolute"
        bottom="1%"
        left="1%"
        color="info.main"
        display="flex"
        alignItems="center"
      >
        <img src={logo} width="50px" alt="Logo"/>
        <Box mr={1} />
        <Typography>Powered by Risk Mentor Digital Engines</Typography>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingY={3}
        width="1"
        height="1"
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flex={0.6}
          padding={4}
          height={1}
          component="form"
        >
          <object data={powernetLogo} width="120%" aria-label="Powernet Logo" />
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flex={0.6}
          padding={10}
          bgcolor="primary.main"
          height="1"
          borderLeft={25}
          borderColor="secondary.main"
        >
          <Box width="0.75">
            <Box mb={3} color="white">
              <Typography variant="h4">Welcome</Typography>
              <Typography variant="body2">
                Please log in with your Risk Mentor user account.
              </Typography>
            </Box>
            <Box mb={1} color="white">
              <CustomTextField
                value={values.userName}
                name="userName"
                onChange={handleChange}
                label="User name"
                variant="outlined"
                fullWidth
                errorMsg={errors.userName}
                labelProps={{ style: { color: 'white' } }}
              />
            </Box>
            <Box mb={3}>
              <CustomTextField
                type="password"
                name="password"
                value={values.password}
                onChange={handleChange}
                label="Password"
                variant="outlined"
                fullWidth
                errorMsg={activeError || errors.password}
                labelProps={{ style: { color: 'white' } }}
              />
            </Box>
            <Box flex={1}>
              <MainButton
                text="Login"
                onClick={handleSubmit}
                disabled={isSubmitting}
                type="submit"
                fullWidth
                className={classes.button}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
  return content;
};

export default Login;
